import React from 'react';
import { useModal } from '@ebay/nice-modal-react';

import { ModalFullScreenDrawer, ModalFullScreenHeader, ModalFullScreenContent } from '@ocx/ui-modals';

import { SmsOptIn, SmsOptInProps } from '../../../pages/SmsOptIn/sms-opt-in.component';

export type SmsOptInPopupControllerProps = SmsOptInProps;

export const SmsOptInPopupController = (props: SmsOptInPopupControllerProps) => {
  const { title, shortDescription, imageUrl, terms, disclaimer, disclaimerUrl, onAccepted, onRejected } = props;

  const modal = useModal();

  return (
    <ModalFullScreenDrawer open={modal.visible} onClose={modal.hide} onExited={modal.remove}>
      <ModalFullScreenHeader />
      <ModalFullScreenContent>
        <SmsOptIn
          title={title}
          shortDescription={shortDescription}
          imageUrl={imageUrl}
          terms={terms}
          disclaimer={disclaimer}
          disclaimerUrl={disclaimerUrl}
          onAccepted={() => {
            modal.hide();
            onAccepted();
          }}
          onRejected={() => {
            modal.hide();
            onRejected();
          }}
        />
      </ModalFullScreenContent>
    </ModalFullScreenDrawer>
  );
};
